// extracted by mini-css-extract-plugin
export var closeButton = "_hd-2";
export var closeButtonIcon = "_hd-3";
export var lightboxContent = "_hd-1";
export var lightboxOverlay = "_hd-0";